export const TOP_AREA_ROOT = 'root';
